import { ScrollbarPlugin } from "smooth-scrollbar";

export default class DisableScrollbarPlugin extends ScrollbarPlugin {
	static pluginName = "disableScroll";

	static defaultOptions = {
		disable: false,
	};

	transformDelta(delta) {
		return this.options.disable ? { x: 0, y: 0 } : delta;
	}
}
